function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from 'react';
import ViewFilterQueryContext from '../../Context/ViewFilterQueryContext';
import useQueryParams from '../../helpers/useQueryParams';

/**
 * @typedef {'memory' | 'url'} ViewFilterQueryStorageType
 */

/**
 * Provider for view filter query context so that child components can access the query filtering state
 * as stored in the URL query string and update it.
 *
 * @param {Object} props The props passed to the component.
 * @param {string} props.pageParam The name of the pagination parameter in the URL query string. Defaults to 'page'.
 * @param {ViewFilterQueryStorageType} props.storageType The type of storage to use for the query parameters. Can be 'memory' or 'url'. Defaults to 'memory'.
 * @param {string} props.pageQueryParam The name of the pagination key in the filter, so that it is known which value should be reset every time a filter is changed. Defaults to 'page'.
 * @param {React.ReactNode} props.children The child components over which the context should be available.
 *
 * @returns {React.ReactNode} The provider component for the view filter query context.
 */
export default function ViewFilterQueryProvider(_ref) {
  var _ref$pageQueryParam = _ref.pageQueryParam,
    pageQueryParam = _ref$pageQueryParam === void 0 ? 'page' : _ref$pageQueryParam,
    _ref$storageType = _ref.storageType,
    storageType = _ref$storageType === void 0 ? 'memory' : _ref$storageType,
    children = _ref.children;
  var _React$useState = React.useState({}),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    queryParamsInMemory = _React$useState2[0],
    setQueryParamsInMemory = _React$useState2[1];
  var _useQueryParams = useQueryParams(),
    _useQueryParams2 = _slicedToArray(_useQueryParams, 2),
    queryParamsInUrl = _useQueryParams2[0],
    setQueryParamsUrl = _useQueryParams2[1];
  var queryParams = storageType === 'url' ? queryParamsInUrl : queryParamsInMemory;
  var setQueryParams = storageType === 'url' ? setQueryParamsUrl : setQueryParamsInMemory;
  var value = React.useMemo(function () {
    return {
      queryParams: queryParams,
      setQueryParams: setQueryParams,
      pageQueryParam: pageQueryParam
    };
  }, [queryParams, setQueryParams, pageQueryParam]);
  return /*#__PURE__*/React.createElement(ViewFilterQueryContext.Provider, {
    value: value
  }, children);
}